import type { ReactNode } from "react";

export type StatusTone = "success" | "warning" | "danger" | "info" | "neutral";

const statusTones: Record<string, StatusTone> = {
  active: "success",
  approved: "success",
  başarılı: "success",
  canlı: "success",
  current: "success",
  güncel: "success",
  görünür: "success",
  onaylandı: "success",
  published: "success",
  resmî: "success",
  success: "success",
  verified: "success",
  yayında: "success",

  changes_requested: "warning",
  draft: "warning",
  in_review: "warning",
  pending: "warning",
  scheduled: "warning",
  taslak: "warning",
  bekliyor: "warning",
  "kontrol bekliyor": "warning",
  "onay bekliyor": "warning",
  "değişiklik istendi": "warning",
  zamanlandı: "warning",

  failed: "danger",
  başarısız: "danger",
  error: "danger",
  askıda: "danger",
  suspended: "danger",

  new: "info",
  yeni: "info",
  reviewing: "info",
  inceleniyor: "info",
  "incelemede": "info",
  "ipf onaylı": "info",
  selected: "info",
  approved_member: "info",
};

function normalizeStatus(value: string) {
  return value.trim().toLocaleLowerCase("tr-TR").replace(/\s+/g, " ");
}

export function StatusBadge({
  children,
  status,
  tone,
}: {
  children: ReactNode;
  status?: string;
  tone?: StatusTone;
}) {
  const resolvedStatus = normalizeStatus(status ?? String(children));
  const resolvedTone = tone ?? statusTones[resolvedStatus] ?? "neutral";
  return (
    <span className={`badge badge-${resolvedTone}`} data-status={resolvedStatus || undefined}>
      <span className="badge-dot" aria-hidden="true" />
      {children}
    </span>
  );
}
